import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Text } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';

import './style.scss';

const propTypes = {
    cronstatus: PropTypes.string,
    enabledSyncLiteral: PropTypes.string,
    errorSyncLiteral: PropTypes.string,
    intialSyncLiteral: PropTypes.string,
};

class SyncStatus extends Component {
    renderStatusBlock = (ovalClass, titleLiteral, descLiteral) => (
        <div className="inside-status-tab-content">
            <div className="status-container">
                <div className={`oval ${ovalClass}`} />
                <Text as="div" className="status-tab-text" medium type="subtitle1">
                    {getLiteral(titleLiteral)}
                </Text>
            </div>
            <Text as="div" className="status-tab-desc" type="body">
                {getLiteral(descLiteral)}
            </Text>
        </div>
    );

    render() {
        const { cronstatus, enabledSyncLiteral, errorSyncLiteral, intialSyncLiteral } = this.props;
        let statusContent;

        if (cronstatus === 'enabled') {
            statusContent = this.renderStatusBlock(
                'oval-green',
                'label_enabled_sync_integration',
                enabledSyncLiteral,
            );
        } else if (cronstatus === 'inprogress') {
            statusContent = this.renderStatusBlock(
                'oval-yellow',
                'label_initial_sync_zendesk',
                intialSyncLiteral,
            );
        } else {
            statusContent = this.renderStatusBlock(
                'oval-red',
                'label_failed_sync_integration',
                errorSyncLiteral,
            );
        }

        return <div className="integrations-status-container">{statusContent}</div>;
    }
}

SyncStatus.propTypes = propTypes;

export default SyncStatus;
